import { gql } from "@apollo/client";

export const TRACERS = gql`
  query Tracers(
    $where: TracerWhereInput
    $take: Int
    $skip: Int
    $like: TracerWhereInput
  ) {
    tracers(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        name
        destination
        type
        isExternal
        isDefault
        source {
          id
          name
          status
        }
        flow {
          id
          process {
            id
            name
            theme
            type
            processStatuses {
              id
              template
              name
              tag
              progress
              order
              color
              background
              moveToNext
              createdDate
              formDefinition
              possibleStatuses {
                order
                nextStatus
                conditions {
                  operation
                  rightOperand
                  leftOperand
                }
              }
              actions {
                id
                type
                args
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
              screens {
                id
                currentPublishedVersion {
                  id
                  versionNumber
                  status
                  htmlContent
                  styleContent
                  bindingManifest {
                    id
                    slots
                  }
                  translationTable {
                    id
                    entries
                  }
                  states {
                    id
                    name
                    order
                    htmlContent
                    conditions
                    bindingManifest {
                      id
                      slots
                    }
                  }
                }
              }
            }
          }
        }
      }
      count
    }
  }
`;

export const TRACER = gql`
  query Tracer($where: TracerWhereInput) {
    tracer(where: $where) {
      id
      name
      destination
      type
      isExternal
      isDefault
      source {
        id
        name
      }
      flow {
        id
        process {
          id
          theme
          processStatuses {
            id
            template
            name
            tag
            progress
            order
            color
            background
            moveToNext
            createdDate
            formDefinition
            possibleStatuses {
              order
              nextStatus
              conditions {
                operation
                rightOperand
                leftOperand
              }
            }
            actions {
              id
              type
              args
              conditions {
                id
                operation
                rightOperand
                leftOperand
              }
            }
            screens {
              id
              currentPublishedVersion {
                id
                versionNumber
                status
                htmlContent
                styleContent
                bindingManifest {
                  id
                  slots
                }
                translationTable {
                  id
                  entries
                }
                states {
                  id
                  name
                  order
                  htmlContent
                  conditions
                  bindingManifest {
                    id
                    slots
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const TRACER_OPTIONS = gql`
  query TracerOptions(
    $where: TracerWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    tracers(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        name
      }
    }
  }
`;

const tracers = { TRACERS, TRACER, TRACER_OPTIONS };

export default tracers;
